module.exports = __webpack_public_path__ + "img/completion_left.c2e53c3a.jpg";